import React, { useState } from "react"
import FormsLogo from "../images/efax.svg"
//import { CATEGORIES } from "../utils/constant"

const DocumentList = ({
  zipFiles,
  onFileClick,
  selectedFile,
  setSelectedFile,
  fetchFilesData,
  listLoading,
  isValidUser,
}) => {
  const [expandedCategories, setExpandedCategories] = useState({}) // State to track expanded categories

  const handleFileClick = (category, file) => {
    setSelectedFile(file)
    onFileClick(category, file) // Call the onFileClick prop with the selected file
  }

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category], // Toggle the expanded state for the category
    }))
  }

  return (
    <div className={`document-list ${listLoading ? "locked" : ""}`}>
      <div className="header-container">
        <div className="logo-container">
          <img src={FormsLogo} height={36} width={100} alt="Logo" />
          {process.env.REACT_APP_ENV === "test" && (
            <div className="corner-ribbon"> TEST ENV</div>
          )}
        </div>
        {isValidUser && (
          <div className="refresh-icon-container">
            {listLoading ? (
              <box
                onClick={() => fetchFilesData()}
                style={{ marginRight: "10px" }}
              >
                Loading files...
              </box>
            ) : (
              <button
                title="Click to reload files"
                className="refresh-button"
                onClick={() => fetchFilesData()}
              >
                ↻
              </button>
            )}
          </div>
        )}
      </div>
      <ul>
        {Object.entries(zipFiles).map(([category, files]) =>
          zipFiles[category].length > 0 ? (
            <li className="document-list-folder-li" key={category}>
              <strong
                className="category"
                onClick={() => toggleCategory(category)}
              >
                <span className="icon">📁</span> {/* Folder icon */}
                {category}
              </strong>
              {expandedCategories[category] && (
                <div className="documentName">
                  <ul>
                    {files.map((file) => (
                      <li
                        key={file.fileName}
                        onClick={
                          file.lockStatus === 1
                            ? undefined // Disable onClick when file is locked
                            : () => handleFileClick(category, file.fileName)
                        }
                        className={`file-item ${
                          selectedFile === file.fileName ? "selected" : ""
                        } ${file.lockStatus === 1 ? "locked" : ""}`}
                      >
                        {file.lockStatus === 1 ? (
                          <span className="file-icon">🔒</span>
                        ) : selectedFile === file.fileName ? (
                          <span className="file-icon">✅</span>
                        ) : (
                          <span className="file-icon">📄</span>
                        )}

                        {file.fileName}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ) : null
        )}
      </ul>
    </div>
  )
}

export default DocumentList
